<template>
  <DecisionTreeViewerView v-if="decisionTree.started" preview-mode />
  <SlotPicker v-else @select="onSlotSelect" />
</template>

<script setup>
import DecisionTreeViewerView from "./DecisionTreeViewerView.vue";

import SlotPicker from "#/decision_tree_viewer/components/SlotPicker.vue";
import { useDecisionTreeStore } from "#/decision_tree_viewer/store/decision-tree";
const { decisionTree, setAppointmentSlot, start: startDecisionTree } = useDecisionTreeStore();

async function onSlotSelect(id) {
  await setAppointmentSlot(id);
  startDecisionTree();
}
</script>
